import evaluaties from '../pages/public/evaluaties/Evaluaties.vue'
import { store } from '@/store/'
export default [
  {
    path: '/peapp/eval/guid/:guid/:type',
    name: 'eval',
    component: evaluaties
  },
  {
    path: '/peapp/eval/guid/:guid/:type/:profgroupID',
    name: 'evalprofgroupid',
    component: evaluaties
  }, 
  {
    path: '/peapp/eval/formid/:formid/:type/:previewvalidations',
    name: 'evalformid',
    component: evaluaties,
    beforeEnter: (to, from, next) => {
      store.commit('setMenuOptions', {
        loadTopbanner: false,
        loadLangChoice: false,
        loadMenu: false,
        loadFixedLinks: false
      })

      next()
    }
  },
  {
    path: '/peapp/eval/read/:guid/:type',
    name: 'evalread',
    component: evaluaties
  }
]
